import Category from "../models/category/category.model";

class CategoryHelper {
    static findCategoryInCategoryHierarchy(categoryId: number, categories?: Category[]): Category | undefined {
        if(!categories) {
            return undefined;
        }

        for (const category of categories) {
            // Check if the current item matches
            if (category.id === categoryId) {
                return category;
            }

            if(!category.children || !category.children.length) {
                continue;
            }

            // If the item has children, search recursively in them
            const foundCategory = this.findCategoryInCategoryHierarchy(categoryId, category.children);

            if(!foundCategory) {
                continue;
            }

            return foundCategory;
        }

        return undefined;
    }
    
    static getChildWithParentCategoryFromChildCategoryId(categoryId: number, categories?: Category[]) : { parent: Category, child: Category } | undefined{
        if(!categories) {
            return undefined;
        }

        for (const category of categories) {
            // Check if the current item matches
            if (category.id === categoryId) {
                return {
                    parent: category,
                    child: category
                };
            }

            if(!category.children || !category.children.length) {
                continue;
            }

            // If the item has children, search recursively in them
            const foundCategory = this.findCategoryInCategoryHierarchy(categoryId, category.children);

            if(!foundCategory) {
                continue;
            }

            return {
                parent: category,
                child: foundCategory
            }; //this would be the parent
        }

        return undefined;
    }
}

export { CategoryHelper };